var _g, _g2, _path, _defs;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgLogoV4(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 150,
    height: 150,
    fill: "none",
    viewBox: "0 0 150 150",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    filter: "url(#a)"
  }, /*#__PURE__*/React.createElement("path", {
    fill: "#86EFAC",
    d: "M61.892 71.904c7.107-7.552 19.11-7.552 26.216 0l23.295 24.754c10.811 11.487 2.666 30.336-13.108 30.336h-46.59c-15.774 0-23.919-18.849-13.108-30.336l23.295-24.754Z"
  }), /*#__PURE__*/React.createElement("path", {
    stroke: "#233B51",
    strokeWidth: 4,
    d: "m86.652 73.275 23.295 24.754c9.609 10.211 2.37 26.965-11.652 26.965h-46.59c-14.022 0-21.261-16.754-11.652-26.965l23.295-24.754c6.318-6.713 16.986-6.713 23.304 0Z"
  }))), _g2 || (_g2 = /*#__PURE__*/React.createElement("g", {
    filter: "url(#b)"
  }, /*#__PURE__*/React.createElement("path", {
    fill: "#86EFAC",
    d: "M88.108 78.096c-7.107 7.552-19.11 7.552-26.216 0L38.597 53.342c-10.81-11.487-2.666-30.336 13.108-30.336h46.59c15.774 0 23.919 18.849 13.108 30.336L88.108 78.096Z"
  }), /*#__PURE__*/React.createElement("path", {
    stroke: "#233B51",
    strokeWidth: 4,
    d: "M63.348 76.725 40.053 51.971c-9.61-10.21-2.37-26.965 11.652-26.965h46.59c14.022 0 21.261 16.754 11.652 26.965L86.652 76.725c-6.318 6.713-16.986 6.713-23.304 0Z"
  }))), _path || (_path = /*#__PURE__*/React.createElement("path", {
    fill: "#233B51",
    d: "M80.805 70.192a9 9 0 0 1-12.61 0L52.712 54.993c-5.75-5.645-1.754-15.422 6.305-15.422h30.967c8.058 0 12.055 9.777 6.304 15.422L80.805 70.192Zm-11.61 18.997a9 9 0 0 1 12.61 0l15.483 15.198c5.751 5.645 1.754 15.423-6.305 15.423H60.016c-8.058 0-12.055-9.778-6.304-15.423l15.483-15.198Z"
  })), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("filter", {
    id: "a",
    width: 90.662,
    height: 68.754,
    x: 29.669,
    y: 66.24,
    colorInterpolationFilters: "sRGB",
    filterUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("feFlood", {
    floodOpacity: 0,
    result: "BackgroundImageFix"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    in: "SourceAlpha",
    result: "hardAlpha",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0"
  }), /*#__PURE__*/React.createElement("feOffset", {
    dy: 4
  }), /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 2
  }), /*#__PURE__*/React.createElement("feComposite", {
    in2: "hardAlpha",
    operator: "out"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0.25 0"
  }), /*#__PURE__*/React.createElement("feBlend", {
    in2: "BackgroundImageFix",
    result: "effect1_dropShadow_120_49"
  }), /*#__PURE__*/React.createElement("feBlend", {
    in: "SourceGraphic",
    in2: "effect1_dropShadow_120_49",
    result: "shape"
  })), /*#__PURE__*/React.createElement("filter", {
    id: "b",
    width: 90.662,
    height: 68.754,
    x: 29.669,
    y: 23.006,
    colorInterpolationFilters: "sRGB",
    filterUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("feFlood", {
    floodOpacity: 0,
    result: "BackgroundImageFix"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    in: "SourceAlpha",
    result: "hardAlpha",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0"
  }), /*#__PURE__*/React.createElement("feOffset", {
    dy: 4
  }), /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 2
  }), /*#__PURE__*/React.createElement("feComposite", {
    in2: "hardAlpha",
    operator: "out"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0.25 0"
  }), /*#__PURE__*/React.createElement("feBlend", {
    in2: "BackgroundImageFix",
    result: "effect1_dropShadow_120_49"
  }), /*#__PURE__*/React.createElement("feBlend", {
    in: "SourceGraphic",
    in2: "effect1_dropShadow_120_49",
    result: "shape"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgLogoV4);
export default __webpack_public_path__ + "static/media/logo_v4.264fb212a760655386f53ccb647e063b.svg";
export { ForwardRef as ReactComponent };